module.exports = __webpack_public_path__ + "static/media/activateimg.4a5ed87a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/activateimg.jpg
// module id = 437
// module chunks = 0